import React, { useEffect, useState, useRef, useCallback } from 'react';
import Layout from '../../components/layout/Layout';
import { getData, postData, putData, deleteData } from '../../services/apiService';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import SearchIcon from '@mui/icons-material/Search';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import CloseIcon from '@mui/icons-material/Close';
import {
    Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography,
    IconButton, Button, Modal, TextField, Select, MenuItem, Pagination, InputAdornment, InputLabel, FormControl
} from '@mui/material';
import Switch from '@mui/material/Switch';
import Progress from '../../hooks/useProgressBar';
import useDebounce from '../../hooks/useDebounce';

const Dashboard = () => {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const isFetched = useRef(false);
    const [showCollegeModal, addCollegeShowModal] = useState(false);
    const [updateCollegeModalShow, updateCollegeModal] = useState(false);
    const [formData, setFormData] = useState({
        collegeName: "", address: "", institutionEmail: "", institutionPhone: "", establishmentYear: "", pinCode: "",
        googleMapsLink: "", instituteType: "", institutionPanCard: "", firstName: "", email: '', phone: '', adhaar: '', designation: '',
        password: '', confirmPassword: '', employee_id: ''
    });
    const [selectedCollege, setSelectedCollege] = useState(null);
    const [inputError, setInputError] = useState('');
    const [errors, setErrors] = useState({});
    const ErrorMessage = ({ error }) => (
        error ? <div className="text-danger small mt-1">{error}</div> : null
    );

    // Pagination and search states
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [searchQuery, setSearchQuery] = useState('');
    const debouncedSearchQuery = useDebounce(searchQuery, 500);
    const [totalPages, setTotalPages] = useState(1);



    // Fetch all College from the API
    // const fetchData = async () => {
    //     setLoading(true);
    //     try {
    //         const response = await getData(`/get-all-colleges?page=${page}&limit=${rowsPerPage}&search=${debouncedSearchQuery}`);
    //         if (response) {
    //             setData(response.data);
    //             setTotalPages(response.totalPages);
    //         }
    //         setLoading(false);
    //     } catch (error) {
    //         console.error('Failed to fetch data', error);
    //         setLoading(false);
    //     }
    // };

    const fetchData = useCallback(async () => {
        setLoading(true);
        try {
            const response = await getData(`/get-all-colleges?page=${page}&limit=${rowsPerPage}&search=${debouncedSearchQuery}`);
            if (response) {
                setData(response.data);
                setTotalPages(response.totalPages);
            }
            setLoading(false);
        } catch (error) {
            console.error('Failed to fetch data', error);
            setLoading(false);
        }
    }, [page, rowsPerPage, debouncedSearchQuery]);

    useEffect(() => {
        if (!isFetched.current) {
            fetchData();
        }
    }, [fetchData]);

    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
        setPage(1); // Reset to first page on new search
    };

    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    };

    const handleRowsPerPageChange = (event) => {
        setRowsPerPage(event.target.value);
        setPage(1);
    };

    const handleInputChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };
    // Add new College!
    const addCollege = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await postData('/create-college', formData);
            setFormData({
                collegeName: "", address: "", institutionEmail: "", institutionPhone: "", establishmentYear: "", pinCode: "",
                googleMapsLink: "", instituteType: "", institutionPanCard: "", firstName: "", email: '', phone: '', adhaar: '', designation: '',
                password: '', confirmPassword: '', employee_id: ''
            });
            setErrors([]);
            addCollegeShowModal(false);
            fetchData();
            setLoading(false);
        } catch (error) {
            setInputError(error.response?.data?.error)
            if (error.response?.data?.errors) {
                // Convert array of errors to object with field names as keys
                const errorsObj = {};
                error.response.data.errors.forEach(err => {
                    errorsObj[err.path] = err.msg;
                });
                setErrors(errorsObj);
            }
            setTimeout(() => {
                setErrors('');
                setInputError('');
            }, 3000);
            setLoading(false);
        }
    };

    // Edit Subject
    const editCollege = (id) => {
        const CollegeData = data.find(college => college._id === id);
        setSelectedCollege(CollegeData);
        updateCollegeModal(true);
    };

    const handleStatusChange = async (id, newStatus) => {
        try {
            setData(data.map(item => item._id === id ? {
                ...item,
                admin: {
                    ...item.admin, isApproved: newStatus
                }
            } : item
            ));
            await putData(`/update-college/${id}`, { isApproved: newStatus });
        } catch (error) {
            console.error('Failed to update status:', error);
            setData(data.map(item => item._id === id ? {
                ...item,
                admin: {
                    ...item.admin, isApproved: !newStatus
                }
            } : item
            ));
        }
    };

    const handlevisibilityStatus = async (id, newStatus) => {
        try {
            setData(data.map(item => item._id === id ? {
                ...item, status: newStatus
            } : item
            ));
            await putData(`/update-college/${id}`, { status: newStatus });
        } catch (error) {
            console.error('Failed to update status:', error);
            setData(data.map(item => item._id === id ? {
                ...item, status: !newStatus
            } : item
            ));
        }
    };

    // Update Subject
    const updateCollege = async () => {
        if (!selectedCollege) return;

        const updatedData = {
            collegeName: selectedCollege.collegeName,
            address: selectedCollege.address,
            institutionEmail: selectedCollege.institutionEmail,
            institutionPhone: selectedCollege.institutionPhone,
            establishmentYear: selectedCollege.establishmentYear,
            pinCode: selectedCollege.pinCode,
            googleMapsLink: selectedCollege.googleMapsLink,
            instituteType: selectedCollege.instituteType,
            institutionPanCard: selectedCollege.institutionPanCard,
            firstName: selectedCollege.admin?.firstName,
            email: selectedCollege.admin?.email,
            phone: selectedCollege.admin?.phone,
            adhaar: selectedCollege.admin?.adhaar,
            designation: selectedCollege.admin?.designation,
            employee_id: selectedCollege.admin?.employee_id,
            // isApproved: selectedCollege.admin?.isApproved
        };

        try {
            await putData(`/update-college/${selectedCollege._id}`, updatedData);
            fetchData();
            updateCollegeModal(false);
            setSelectedCollege(null); // Reset selected college after update
        } catch (error) {
            if (error.response?.data?.errors) {
                const errorsObj = {};
                error.response.data.errors.forEach(err => {
                    errorsObj[err.path] = err.msg;
                });
                setErrors(errorsObj);
            }
            console.error('Failed to update college', error);
        }
    };

    // Delete College!
    const CollegeDelete = async (id) => {

        try {
            await deleteData(`/delete-college/${id}`);
            await fetchData();
        } catch (error) {
            console.error("Error:", error);
        }
    };

    // For Add Institute Modal
    const handleAddInstituteModalClose = (event, reason) => {
        if (reason && reason === "backdropClick") return;
        addCollegeShowModal(false);
    };

    // For Update Institute Modal
    const handleUpdateInstituteModalClose = (event, reason) => {
        if (reason && reason === "backdropClick") return;
        updateCollegeModal(false);
    };

    return (
        <Layout>
            {loading ? <Progress /> :
                <Box className="p-6 bg-gray-100 min-h-screen">
                    <Typography variant="h5" component="h1" sx={{ fontWeight: 'bold', mb: 3 }}>Add Institute</Typography>
                    {/* Header: Add Button (left) and Search (right) */}
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, flexWrap: 'wrap', gap: 2, }} >
                        <Button variant="contained" sx={{
                            borderRadius: 2, fontWeight: 600, boxShadow: 2, px: 3, py: 1, textTransform: 'none', backgroundColor: '#4B49AC',
                            '&:hover': { backgroundColor: '#3A3897', },
                        }} onClick={() => addCollegeShowModal(true)} > + Add Institute </Button>
                        <TextField placeholder="Search Departments" value={searchQuery} onChange={handleSearchChange} variant="outlined" size="medium"
                            sx={{ width: 350, bgcolor: '#e9ecef', borderRadius: 2, '& .MuiOutlinedInput-root': { borderRadius: 2, }, }}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon sx={{ color: '#757575' }} />
                                    </InputAdornment>
                                ),
                                sx: { bgcolor: '#e9ecef', borderRadius: 2 },
                            }}
                        />
                    </Box>
                    {/* Table */}
                    {/* <TableContainer component={Paper} elevation={0} sx={{ mb: 2, borderRadius: 2, boxShadow: 2, overflow: 'hidden', }} > */}
                    <TableContainer component={Paper}
                        sx={{
                            width: "100%",
                            maxWidth: "100%",
                            overflowX: "auto",
                            overflowY: "hidden",
                            "&::-webkit-scrollbar": {
                                height: "8px"
                            },
                            "&::-webkit-scrollbar-thumb": {
                                backgroundColor: "#888",
                                borderRadius: "4px"
                            }
                        }}
                    >

                        <Table>
                            <TableHead>
                                <TableRow sx={{ bgcolor: '#4B49AC' }}>
                                    <TableCell align="center" sx={{ color: 'white', fontWeight: 600, borderTopLeftRadius: 8 }}> ID </TableCell>
                                    <TableCell align="center" sx={{ color: 'white', fontWeight: 600 }}> Institute </TableCell>
                                    <TableCell align="center" sx={{ color: 'white', fontWeight: 600 }}> Establishment Year </TableCell>
                                    <TableCell align="center" sx={{ color: 'white', fontWeight: 600 }}> Institute Type </TableCell>
                                    <TableCell align="center" sx={{ color: 'white', fontWeight: 600 }}> Institution Email </TableCell>
                                    <TableCell align="center" sx={{ color: 'white', fontWeight: 600 }}> Address </TableCell>
                                    <TableCell align="center" sx={{ color: 'white', fontWeight: 600 }}> User Name </TableCell>
                                    <TableCell align="center" sx={{ color: 'white', fontWeight: 600 }}> Employee Id </TableCell>
                                    <TableCell align="center" sx={{ color: 'white', fontWeight: 600 }}> Status </TableCell>
                                    <TableCell align="center" sx={{ color: 'white', fontWeight: 600 }}> visibility </TableCell>
                                    <TableCell align="center" sx={{ color: 'white', fontWeight: 600, borderTopRightRadius: 8 }}> Action </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {data.map((item, index) => (
                                    <TableRow key={item._id}>
                                        <TableCell align="center">
                                            <Typography variant="body1">{(page - 1) * rowsPerPage + index + 1}</Typography>
                                        </TableCell>
                                        <TableCell align="center">
                                            <Typography variant="body1">{item.collegeName}</Typography>
                                        </TableCell>
                                        <TableCell align="center">
                                            <Typography variant="body1">{item.establishmentYear}</Typography>
                                        </TableCell>
                                        <TableCell align="center">
                                            <Typography variant="body1">{item.instituteType}</Typography>
                                        </TableCell>
                                        <TableCell align="center">
                                            <Typography variant="body1">{item.institutionEmail}</Typography>
                                        </TableCell>
                                        <TableCell align="center">
                                            <Typography variant="body1">{item.address}</Typography>
                                        </TableCell>
                                        <TableCell align="center">
                                            <Typography variant="body1">{item?.admin?.firstName}</Typography>
                                        </TableCell>
                                        <TableCell align="center">
                                            <Typography variant="body1">{item?.admin?.employee_id}</Typography>
                                        </TableCell>
                                        <TableCell align="center">
                                            <Switch
                                                checked={item?.admin?.isApproved || false}
                                                onChange={() => handleStatusChange(item._id, !item?.admin?.isApproved)}
                                                sx={{
                                                    '& .MuiSwitch-switchBase.Mui-checked': {
                                                        color: '#4caf50',
                                                    },
                                                    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                                        backgroundColor: '#4caf50',
                                                    },
                                                    '& .MuiSwitch-switchBase': {
                                                        color: '#f44336',
                                                    },
                                                    '& .MuiSwitch-track': {
                                                        backgroundColor: '#f44336',
                                                    },
                                                }}
                                            />
                                        </TableCell>

                                        <TableCell align="center">
                                            <Switch
                                                checked={item?.status || false}
                                                onChange={() => handlevisibilityStatus(item._id, !item?.status)}
                                                sx={{
                                                    '& .MuiSwitch-switchBase.Mui-checked': {
                                                        color: '#4caf50',
                                                    },
                                                    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                                        backgroundColor: '#4caf50',
                                                    },
                                                    '& .MuiSwitch-switchBase': {
                                                        color: '#f44336',
                                                    },
                                                    '& .MuiSwitch-track': {
                                                        backgroundColor: '#f44336',
                                                    },
                                                }}
                                            />
                                        </TableCell>
                                        <TableCell align="center">
                                            <IconButton color="primary" onClick={() => editCollege(item._id)}>
                                                <EditIcon />
                                            </IconButton>
                                            <IconButton color="error" onClick={() => CollegeDelete(item._id)}>
                                                <DeleteIcon />
                                            </IconButton>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>

                    {/* Pagination */}
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                        <Pagination count={totalPages} page={page} onChange={handlePageChange} shape="rounded"
                            sx={{
                                '& .MuiPaginationItem-root': {
                                    '&.Mui-selected': {
                                        bgcolor: '#4B49AC',
                                        color: 'white',
                                    },
                                },
                            }}
                        />
                        <Select value={rowsPerPage} onChange={handleRowsPerPageChange} size="small"
                            sx={{ ml: 2, height: 35, bgcolor: '#f7f7f7', border: '1px solid #e2e2e2', '& .MuiSelect-select': { py: 0.75 }, }}
                            IconComponent={KeyboardArrowDownIcon} >
                            <MenuItem value={10}>10 / page</MenuItem>
                            <MenuItem value={20}>20 / page</MenuItem>
                            <MenuItem value={50}>50 / page</MenuItem>
                        </Select>
                    </Box>

                    {/* College Add model */}
                    <Modal open={showCollegeModal} onClose={handleAddInstituteModalClose} aria-labelledby="add-college-modal" className='overflow'>
                        <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 900, bgcolor: 'background.paper', boxShadow: 24, p: 4, borderRadius: 2, }}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                                <Typography variant="h6" component="h2">
                                    Add Institute
                                </Typography>
                                <IconButton onClick={() => addCollegeShowModal(false)}
                                    sx={{ position: 'absolute', right: 8, top: 8, color: 'gray' }} >
                                    <CloseIcon />
                                </IconButton>
                            </Box>
                            <form onSubmit={addCollege}>
                                <Box sx={{ display: 'flex', gap: 2 }}>
                                    <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                                        <TextField fullWidth label={<> College Name <span style={{ color: 'red' }}>*</span> </>} name="collegeName" value={formData.collegeName} onChange={handleInputChange}
                                            margin="normal" sx={{ flex: 1 }} />
                                        <ErrorMessage error={errors.collegeName} />
                                    </Box>
                                    <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                                        <TextField fullWidth label={<> College Address <span style={{ color: 'red' }}>*</span> </>} name="address" value={formData.address} onChange={handleInputChange}
                                            margin="normal" sx={{ flex: 1 }} />
                                        <ErrorMessage error={errors.address} />
                                    </Box>
                                    <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                                        <TextField fullWidth label={<> Institution Email <span style={{ color: 'red' }}>*</span> </>} name="institutionEmail" value={formData.institutionEmail} onChange={handleInputChange}
                                            margin="normal" sx={{ flex: 1 }} />
                                        <ErrorMessage error={errors.address} />
                                    </Box>
                                </Box>
                                <Box sx={{ display: 'flex', gap: 2 }}>
                                    <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                                        <TextField fullWidth label={<> Institution Phone <span style={{ color: 'red' }}>*</span> </>} name="institutionPhone" value={formData.institutionPhone} onChange={handleInputChange}
                                            margin="normal" sx={{ flex: 1 }} />
                                        <ErrorMessage error={errors.establishmentYear} />
                                    </Box>
                                    <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                                        <TextField fullWidth type='month' label={<> Establishment Year <span style={{ color: 'red' }}>*</span> </>} name="establishmentYear" value={formData.establishmentYear} onChange={handleInputChange}
                                            margin="normal" sx={{ flex: 1 }} InputLabelProps={{ shrink: true }} />
                                        <ErrorMessage error={errors.establishmentYear} />
                                    </Box>
                                    <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                                        <TextField fullWidth label={<> Pin Code <span style={{ color: 'red' }}>*</span> </>} name="pinCode" value={formData.pinCode} onChange={handleInputChange}
                                            margin="normal" sx={{ flex: 1 }} />
                                        <ErrorMessage error={errors.pinCode} />
                                    </Box>
                                </Box>
                                <Box sx={{ display: 'flex', gap: 2 }}>
                                    <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                                        <TextField fullWidth label={<> Google Maps Link <span style={{ color: 'red' }}>*</span> </>} name="googleMapsLink" value={formData.googleMapsLink} onChange={handleInputChange}
                                            margin="normal" sx={{ flex: 1 }} />
                                        <ErrorMessage error={errors.googleMapsLink} />
                                    </Box>
                                    <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                                        <FormControl fullWidth margin="normal" sx={{ flex: 1 }}>
                                            <InputLabel>Institute Typelabel <span style={{ color: 'red' }}>*</span></InputLabel>
                                            <Select name="instituteType" value={formData.instituteType} onChange={handleInputChange} label="Institute Type" >
                                                <MenuItem value="University">University</MenuItem>
                                                <MenuItem value="College">College</MenuItem>
                                                <MenuItem value="University Campus">University Campus</MenuItem>
                                                <MenuItem value="University Campus">College Campus</MenuItem>
                                            </Select>
                                        </FormControl>
                                        <ErrorMessage error={errors.instituteType} />
                                    </Box>
                                    <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                                        <TextField fullWidth label={<> Institution Pan Card <span style={{ color: 'red' }}>*</span> </>} name="institutionPanCard" value={formData.institutionPanCard} onChange={handleInputChange}
                                            margin="normal" sx={{ flex: 1 }} />
                                        <ErrorMessage error={errors.institutionPanCard} />
                                    </Box>
                                </Box>
                                <Box sx={{ display: 'flex', mt: 3 }}>
                                    <Typography variant="h6" component="h2">
                                        Point of Contact
                                    </Typography>
                                </Box>
                                <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
                                    <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                                        <TextField fullWidth label={<> Name <span style={{ color: 'red' }}>*</span> </>} name="firstName" value={formData.firstName} onChange={handleInputChange}
                                            margin="normal" sx={{ flex: 1 }} />
                                        <ErrorMessage error={errors.firstName} />
                                    </Box>
                                    <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                                        <TextField fullWidth label={<> Email <span style={{ color: 'red' }}>*</span> </>} name="email" value={formData.email} onChange={handleInputChange}
                                            margin="normal" sx={{ flex: 1 }} />
                                        <ErrorMessage error={errors.email} />
                                    </Box>
                                    <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                                        <TextField fullWidth label={<> Phone <span style={{ color: 'red' }}>*</span> </>} name="phone" value={formData.phone} onChange={handleInputChange}
                                            margin="normal" sx={{ flex: 1 }} />
                                        <ErrorMessage error={errors.phone} />
                                    </Box>
                                </Box>
                                <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
                                    <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                                        <TextField fullWidth label={<> Adhaar Number <span style={{ color: 'red' }}>*</span> </>} name="adhaar" value={formData.adhaar} onChange={handleInputChange}
                                            margin="normal" sx={{ flex: 1 }} />
                                        <ErrorMessage error={errors.adhaar} />
                                    </Box>
                                    <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                                        <TextField fullWidth label="Designation" name="designation" value={formData.designation} onChange={handleInputChange}
                                            margin="normal" sx={{ flex: 1 }} />
                                        <ErrorMessage error={errors.designation} />
                                    </Box>
                                    <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                                        <TextField fullWidth label={<> Employee Id <span style={{ color: 'red' }}>*</span> </>} name="employee_id" value={formData.employee_id} onChange={handleInputChange}
                                            margin="normal" sx={{ flex: 1 }} />
                                        <ErrorMessage error={errors.employee_id} />
                                    </Box>
                                </Box>
                                <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
                                    <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                                        <TextField fullWidth type="password" label={<> Password <span style={{ color: 'red' }}>*</span> </>} name="password" value={formData.password}
                                            onChange={handleInputChange} margin="normal" sx={{ flex: 1 }} />
                                        <ErrorMessage error={errors.password} />
                                    </Box>
                                    <TextField fullWidth type="password" label={<> Confirm Password <span style={{ color: 'red' }}>*</span> </>} name="confirmPassword"
                                        value={formData.confirmPassword} onChange={handleInputChange} margin="normal" sx={{ flex: 1 }} />
                                </Box>

                                {inputError && (
                                    <Typography color="error" align="left" sx={{ mb: 2 }}>
                                        {inputError}
                                    </Typography>
                                )}

                                <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
                                    <Button variant="contained" type="submit" color="primary" sx={{ bgcolor: '#3A3897', '&:hover': { bgcolor: '#2A2878', } }}>
                                        Save
                                    </Button>
                                </Box>
                            </form>
                        </Box>
                    </Modal>

                    {/* College update model */}
                    <Modal open={updateCollegeModalShow} onClose={handleUpdateInstituteModalClose} aria-labelledby="update-college-modal" className='overflow'>
                        <Box sx={{
                            position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 900,
                            bgcolor: 'background.paper', boxShadow: 24, p: 4, borderRadius: 2,
                        }}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                                <Typography variant="h6" component="h2">
                                    Update Institute
                                </Typography>
                                <IconButton onClick={() => updateCollegeModal(false)} sx={{ position: 'absolute', right: 8, top: 8, color: 'gray' }} >
                                    <CloseIcon />
                                </IconButton>
                            </Box>
                            <form>
                                <Box sx={{ display: 'flex', gap: 2 }}>
                                    <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                                        <TextField fullWidth label="College Name" value={selectedCollege?.collegeName || ""}
                                            onChange={(e) => setSelectedCollege({ ...selectedCollege, collegeName: e.target.value })} margin="normal" />
                                        <ErrorMessage error={errors.collegeName} />
                                    </Box>
                                    <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                                        <TextField fullWidth label="College Address" value={selectedCollege?.address || ""}
                                            onChange={(e) => setSelectedCollege({ ...selectedCollege, address: e.target.value })} margin="normal" />
                                        <ErrorMessage error={errors.address} />
                                    </Box>
                                    <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                                        <TextField fullWidth label="Institution Email" value={selectedCollege?.institutionEmail || ""}
                                            onChange={(e) => setSelectedCollege({ ...selectedCollege, institutionEmail: e.target.value })} margin="normal" />
                                        <ErrorMessage error={errors.institutionEmail} />
                                    </Box>
                                </Box>
                                <Box sx={{ display: 'flex', gap: 2 }}>
                                    <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                                        <TextField fullWidth label="Institution Phone" name="institutionPhone" value={selectedCollege?.institutionPhone || ""}
                                            onChange={(e) => setSelectedCollege({ ...selectedCollege, institutionPhone: e.target.value })} margin="normal" sx={{ flex: 1 }} />
                                        <ErrorMessage error={errors.establishmentYear} />
                                    </Box>
                                    <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                                        <TextField fullWidth label="Establishment Year" name="establishmentYear" value={selectedCollege?.establishmentYear || ""}
                                            onChange={(e) => setSelectedCollege({ ...selectedCollege, establishmentYear: e.target.value })} margin="normal" sx={{ flex: 1 }} />
                                        <ErrorMessage error={errors.establishmentYear} />
                                    </Box>
                                    <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                                        <TextField fullWidth label="Pin Code" name="pinCode" value={selectedCollege?.pinCode || ""}
                                            onChange={(e) => setSelectedCollege({ ...selectedCollege, pinCode: e.target.value })} margin="normal" sx={{ flex: 1 }} />
                                        <ErrorMessage error={errors.pinCode} />
                                    </Box>
                                </Box>
                                <Box sx={{ display: 'flex', gap: 2 }}>
                                    <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                                        <TextField fullWidth label="Google Maps Link" name="googleMapsLink" value={selectedCollege?.googleMapsLink || ""}
                                            onChange={(e) => setSelectedCollege({ ...selectedCollege, googleMapsLink: e.target.value })} margin="normal" sx={{ flex: 1 }} />
                                        <ErrorMessage error={errors.googleMapsLink} />
                                    </Box>
                                    <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                                        <FormControl fullWidth margin="normal" sx={{ flex: 1 }}>
                                            <InputLabel>Institute Type</InputLabel>
                                            <Select name="instituteType" value={selectedCollege?.instituteType || ""} onChange={(e) => setSelectedCollege({ ...selectedCollege, instituteType: e.target.value })} label="Institute Type" >
                                                <MenuItem value="University">University</MenuItem>
                                                <MenuItem value="College">College</MenuItem>
                                                <MenuItem value="University Campus">University Campus</MenuItem>
                                                <MenuItem value="University Campus">College Campus</MenuItem>
                                            </Select>
                                        </FormControl>
                                        <ErrorMessage error={errors.instituteType} />
                                    </Box>
                                    <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                                        <TextField fullWidth label="Institution Pan Card" name="institutionPanCard" value={selectedCollege?.institutionPanCard || ""}
                                            onChange={(e) => setSelectedCollege({ ...selectedCollege, institutionPanCard: e.target.value })} margin="normal" sx={{ flex: 1 }} />
                                        <ErrorMessage error={errors.institutionPanCard} />
                                    </Box>
                                </Box>
                                <Box sx={{ display: 'flex', mt: 3 }}>
                                    <Typography variant="h6" component="h2">
                                        Point of Contact
                                    </Typography>
                                </Box>
                                <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
                                    <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                                        <TextField fullWidth label="Name" name="firstName" value={selectedCollege?.admin?.firstName || ""}
                                            onChange={(e) => setSelectedCollege({ ...selectedCollege, admin: { ...selectedCollege?.admin, firstName: e.target.value } })}
                                            margin="normal" sx={{ flex: 1 }} />
                                        <ErrorMessage error={errors.firstName} />
                                    </Box>
                                    <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                                        <TextField fullWidth label="Email" name="email" value={selectedCollege?.admin?.email || ""}
                                            onChange={(e) => setSelectedCollege({
                                                ...selectedCollege, admin: { ...selectedCollege?.admin, email: e.target.value }
                                            })} margin="normal" sx={{ flex: 1 }} />
                                        <ErrorMessage error={errors.email} />
                                    </Box>
                                    <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                                        <TextField fullWidth label="Phone" name="phone" value={selectedCollege?.admin?.phone || ""}
                                            onChange={(e) => setSelectedCollege({ ...selectedCollege, admin: { ...selectedCollege?.admin, phone: e.target.value } })}
                                            margin="normal" sx={{ flex: 1 }} />
                                        <ErrorMessage error={errors.phone} />
                                    </Box>
                                </Box>
                                <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
                                    <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                                        <TextField fullWidth label="Adhaar Number" name="adhaar" value={selectedCollege?.admin?.adhaar || ""}
                                            onChange={(e) => setSelectedCollege({ ...selectedCollege, admin: { ...selectedCollege?.admin, adhaar: e.target.value } })}
                                            margin="normal" sx={{ flex: 1 }} />
                                        <ErrorMessage error={errors.adhaar} />
                                    </Box>
                                    <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                                        <TextField fullWidth label="Designation" name="designation" value={selectedCollege?.admin?.designation || ""}
                                            onChange={(e) => setSelectedCollege({ ...selectedCollege, admin: { ...selectedCollege?.admin, designation: e.target.value } })}
                                            margin="normal" sx={{ flex: 1 }} />
                                        <ErrorMessage error={errors.designation} />
                                    </Box>
                                    <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                                        <TextField fullWidth label="Employee Id" name="employee_id" value={selectedCollege?.admin?.employee_id || ""}
                                            onChange={(e) => setSelectedCollege({ ...selectedCollege, admin: { ...selectedCollege?.admin, employee_id: e.target.value } })}
                                            margin="normal" sx={{ flex: 1 }} InputProps={{ readOnly: true }} />
                                        <ErrorMessage error={errors.employee_id} />
                                    </Box>
                                </Box>
                                <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
                                    <Button variant="contained" onClick={updateCollege} color="primary" sx={{ bgcolor: '#3A3897', '&:hover': { bgcolor: '#2A2878', } }}>
                                        Save changes
                                    </Button>
                                </Box>
                            </form>
                        </Box>
                    </Modal>
                </Box>
            }
        </Layout>
    );
};

export default Dashboard;